import { launchConfetti } from './ConfettiEffect'

export const effectHandlers = {
  confetti: launchConfetti
}
